import gsap from 'gsap';
// import Carousel from "../carousel/carousel";
import { each } from 'lodash';

import Swiper from 'swiper';
import ColorThief from '../../../../node_modules/colorthief/dist/color-thief.mjs'
import imagesLoaded from 'imagesloaded';


export class Hero {
    constructor() {
        this.hero = {
            section: document.querySelector('.hero'),
            preview: document.querySelector('.hero [data-preview]'),
            image: document.querySelector('.hero [data-preview] img')
        }

        this.carousel = {
            count: 0,
            controls: this.hero.section.querySelector('[data-controls]'),
            title: {
                line: document.querySelector('.carousel [data-titles] [data-line]'),
                kind: document.querySelector('.carousel [data-titles] [data-kind]'),
                designer: document.querySelector('.carousel [data-titles] [data-designer]'),
            },
            element: document.querySelector('.carousel[data-carousel="single-items"]'),
            slides: document.querySelectorAll('.carousel[data-carousel="single-items"] [data-slide]'),
            images: document.querySelectorAll('.carousel[data-carousel="single-items"] img[data-subject]'),
            prev: document.querySelector('.carousel[data-carousel="single-items"] [data-arrow][data-prev]'),
            next: document.querySelector('.carousel[data-carousel="single-items"] [data-arrow][data-next]'),
            children: document.querySelector('.carousel[data-carousel="single-items"]').getAttribute('data-children') > 0,
            hasVideo: document.querySelector('.carousel[data-carousel="single-items"]').querySelector('[data-video]') !== null,
            videos: document.querySelectorAll('.carousel[data-carousel="single-items"] [data-video] video'),
        }

        if(this.carousel.hasVideo){ 
            this.hero.section.classList.add('has--video')

            each(this.carousel.videos, (video) => {
                video.onloadeddata = (event) => { // On Video Loaded
                    gsap.to(event.target.parentNode.querySelector('img[data-subject]'), {
                        autoAlpha: 0,
                        overwrite: 'auto'
                    })

                    gsap.to(event.target, { 
                        delay: 1,
                        autoAlpha: 1,
                        overwrite: 'auto'
                    })
                }
            })
        }

        this.preloader = new imagesLoaded(this.carousel.images);

        this.preloader.on( 'done', ( instance ) => {
            each(instance.images, (image) => {
                var status = image.isLoaded ? 202 : 404;
    
                if(status === 404){ 
                    console.log(image.img.src, status)
                }
            })

            this.createCarousel(this.carousel.element); // Init Carousel
        })
    }

    createCarousel(target) {
        let carousel = new Swiper(target, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: "fade",
            // autoplay: {
            //     delay: this.carousel.hasVideo ? 8000 : 5000,
            // },
            autoplay: false,
            speed: 1200,
            loop: false,
            rewind: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        })

        // Only if has a video Inside
        if(this.carousel.hasVideo){
            this.videoBehaviour(carousel)
        } else {
            carousel.on('slideNextTransitionStart slidePrevTransitionStart', () => {
                this.carousel.prev.style.pointerEvents = 'none'
                this.carousel.next.style.pointerEvents = 'none'
    
                let currentSlide = carousel.slides[carousel.activeIndex]
    
                // each(this.carousel.images, (image) => {
                //     gsap.to(image, {
                //         autoAlpha: 0,
                //     })
                // })
    
                // gsap.to(currentSlide.querySelector('img[data-subject]'), {
                //     autoAlpha: 1,
                // })
            })
    
            carousel.on('slideNextTransitionEnd slidePrevTransitionEnd', () => {
                this.carousel.prev.style.pointerEvents = 'auto'
                this.carousel.next.style.pointerEvents = 'auto'
            })
        }
    }

    videoBehaviour = (carousel) => {
        each(this.carousel.videos, (video) => {
            video.onloadeddata = (event) => { // On Video Loaded
                gsap.to(event.target.parentNode.querySelector('img[data-subject]'), {
                    autoAlpha: 0,
                    overwrite: true
                })

                gsap.to(event.target, { 
                    delay: 1,
                    autoAlpha: 1,
                    overwrite: true
                })
            }

            video.onended = (event) => { // On video end go to next slide
                carousel.slideNext()
                event.target.currentTime = 0
            }
        })

        if (carousel.slides[carousel.activeIndex].hasAttribute('data-video')) {
            var currentVideo = this.carousel.videos[carousel.realIndex]

            currentVideo.play() // Play the video to load the meta
        }

        carousel.on('slideNextTransitionStart slidePrevTransitionStart', () => {
            this.carousel.prev.style.pointerEvents = 'none'
            this.carousel.next.style.pointerEvents = 'none'

            let currentSlide = carousel.slides[carousel.activeIndex]
            let currentVideo = currentSlide.querySelector('video')

            each(this.carousel.videos, (video)=> {
                gsap.to(video, {
                    duration: carousel.originalParams.speed / 1000,
                    autoAlpha: 0,
                    onComplete: () => {
                        video.pause()
                        video.currentTime = 0.1
                    }
                })
            })

            each(this.carousel.images, (image) => {
                gsap.to(image, {
                    autoAlpha: 0,
                })
            })

            gsap.to(currentSlide.querySelector('img[data-subject]'), {
                autoAlpha: 1,
            })

            currentVideo.currentTime = 0.1
        })

        carousel.on('slideNextTransitionEnd slidePrevTransitionEnd', () => {
            this.carousel.prev.style.pointerEvents = 'auto'
            this.carousel.next.style.pointerEvents = 'auto'

            let currentSlide = carousel.slides[carousel.activeIndex]
            let currentVideo = currentSlide.querySelector('video')

            currentVideo.play()
            
            gsap.to(currentSlide.querySelector('img[data-subject]'), {
                delay: .5,
                autoAlpha: 0,
            })

            if(currentVideo.readyState >= 2){

                gsap.to(currentVideo, {
                    delay: 1,
                    autoAlpha: 1, 
                    overwrite: true,
                    onStart: () => {
                        currentVideo.currentTime = 0.1
                        currentVideo.play()
                    } 
                })
            }
        })
    }
}

export class HeroAuto {
    constructor() {
        this.hero = {
            section: document.querySelector('.hero--auto'),
            preview: document.querySelector('.hero--auto [data-preview]'),
            image: document.querySelector('.hero--auto [data-preview] img')
        }

        this.carousel = {
            count: 0,
            controls: document.querySelector('.hero--auto [data-controls]'),
            title: {
                line: document.querySelector('.carousel [data-titles] [data-line]'),
                kind: document.querySelector('.carousel [data-titles] [data-kind]'),
                designer: document.querySelector('.carousel [data-titles] [data-designer]'),
            },
            element: document.querySelector('.carousel[data-carousel="auto-items"]'),
            slides: document.querySelectorAll('.carousel[data-carousel="auto-items"] [data-slide]'),
            prev: document.querySelector('[data-controls] [data-prev]'),
            next: document.querySelector('[data-controls] [data-next]'),
            children: document.querySelector('.carousel[data-carousel="auto-items"]').getAttribute('data-children') > 0,
            hasVideo: document.querySelector('.carousel[data-carousel="auto-items"]').querySelector('[data-video]') !== null,
            video: document.querySelector('.carousel[data-carousel="auto-items"] [data-video] video'),
        }

        this.color = {
            picker: new ColorThief(),
            maps: new Array(),
        }

        this.setCarousel(); // Set Preview out of the viewport

        if(this.carousel.hasVideo){ 
            this.hero.section.classList.add('has--video')
            
            gsap.set(this.carousel.video, { autoAlpha: 0 })
            gsap.set(this.carousel.controls, { autoAlpha: 0 })
            this.carousel.video.play()

            this.carousel.video.onloadeddata = (event) => { // On Video Loaded
                gsap.to(this.carousel.video, { 
                    autoAlpha: 1,
                })
            }
        }

        this.preloader = new imagesLoaded(this.carousel.element.querySelectorAll('img[data-subject]'));

        this.preloader.on( 'done', ( instance ) => {
            each(instance.images, (image) => {
                var status = image.isLoaded ? 202 : 404;
    
                if(status === 404){ 
                    console.log(image.img.src, status)
                    image.crossOrigin = 'anonymous';
                }
            })

            this.setColors()
            this.createCarousel(this.carousel.element); // Init Carousel
        })
    }

    setCarousel() {
        gsap.set(this.carousel.element, { autoAlpha: 0})

        gsap.to(this.carousel.title.line, { autoAlpha: 0, y: 20 })
        gsap.to(this.carousel.title.kind, { autoAlpha: 0, y: -10 })
        gsap.to(this.carousel.title.designer, { autoAlpha: 0 })
    }

    setColors = () => {
        each(this.carousel.slides, (slide) => {
            var image = slide.querySelector('img[data-subject]');
            var color = this.color.picker.getColor(image)

            if(color[0] > 200 || color[1] > 200 || color[2] > 200){
                color = this.color.picker.getPalette(image, 2)[1]
                console.log(color)
            }

            this.color.maps.push(color)
        })
    }

    createCarousel(target) {
        let carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: 1200,
            autoplay: false,
            loop: false,
            navigation: {
                nextEl: "[data-arrow][data-next]",
                prevEl: "[data-arrow][data-prev]",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            centeredSlides: true,
        });

        this.colorDetection(carousel.realIndex, this.carousel.element)
        gsap.to(this.carousel.element, { autoAlpha: 1 })

        gsap.to(this.carousel.title.line, { delay: 1, autoAlpha: 1, y: 0 })
        gsap.to(this.carousel.title.kind, { delay: 1, autoAlpha: 1, y: 0 })
        gsap.to(this.carousel.title.designer, { delay: 1, autoAlpha: 1 })

        if(this.carousel.hasVideo){
            this.carousel.video.onloadedmetadata = (event) => {
                console.log(event);
            }
        }

        var nextSlide = carousel.slides[carousel.activeIndex+1 > carousel.slides.length ? 0 : carousel.activeIndex+1]

        if(nextSlide){
            gsap.set(nextSlide.querySelector('img'), { left: 0, right: 200 })
        }

        carousel.on('slideChange', () => {
            this.colorDetection(carousel.realIndex, this.carousel.element)
        })

        // On Next Transition Begins
        carousel.on('slideNextTransitionStart slidePrevTransitionStart', () => {
            this.carousel.prev.style.pointerEvents = 'none'
            this.carousel.next.style.pointerEvents = 'none'

            let prevSlide = carousel.slides[carousel.previousIndex],
                nextSlide = carousel.slides[carousel.activeIndex+1 > carousel.slides.length ? 0 : carousel.activeIndex+1],
                currentSlide = carousel.slides[carousel.activeIndex]

                console.log({carousel})

            if(prevSlide){
                gsap.to(prevSlide.querySelector('img'), {
                    duration: carousel.originalParams.speed / 1000,
                    right: 0,
                    left: 200,
                    ease: 'Power3.easeOut'
                })
            }

            if(nextSlide){
                gsap.to(nextSlide.querySelector('img'), {
                    duration: carousel.originalParams.speed / 1000,
                    left: 0,
                    right: 200,
                    ease: 'Power3.easeOut'
                })
            }

            gsap.to(currentSlide.querySelector('img'), {
                duration: carousel.originalParams.speed / 1000,
                right: 0,
                left: 0,
                ease: 'Power3.easeOut'
            })
        })

        carousel.on('slideNextTransitionEnd slidePrevTransitionEnd', () => {
            this.carousel.prev.style.pointerEvents = 'auto'
            this.carousel.next.style.pointerEvents = 'auto'
        })
    }

    colorDetection = (image, carousel) => {
        gsap.to(carousel, {
            duration: 1,
            backgroundColor: `rgb(${this.color.maps[image][0]},${this.color.maps[image][1]},${this.color.maps[image][2]})`,
        })
    }
}

export class HeroLanding {
    constructor() {
        this.hero = {
            section: document.querySelector('.hero--landing'),
            preview: document.querySelector('.hero--landing [data-preview]'),
            image: document.querySelector('.hero--landing [data-preview] img')
        }

        this.carousel = {
            count: 0,
            controls: this.hero.section.querySelector('[data-controls]'),
            title: {
                line: this.hero.section.querySelector('.carousel [data-titles] [data-line]'),
                kind: this.hero.section.querySelector('.carousel [data-titles] [data-kind]'),
                designer: this.hero.section.querySelector('.carousel [data-titles] [data-designer]'),
            },
            element: this.hero.section.querySelector('.carousel[data-carousel="single-items"]'),
            slides: this.hero.section.querySelector('.carousel[data-carousel="single-items"] [data-slide]'),
            images: this.hero.section.querySelector('.carousel[data-carousel="single-items"] img[data-subject]'),
            prev: this.hero.section.querySelector('[data-controls] [data-arrow][data-prev]'),
            next: this.hero.section.querySelector('[data-controls] [data-arrow][data-next]'),
            children: this.hero.section.querySelector('.carousel[data-carousel="single-items"]').getAttribute('data-children') > 0,
            hasVideo: this.hero.section.querySelector('.carousel[data-carousel="single-items"]').querySelector('[data-video]') !== null,
            videos: this.hero.section.querySelectorAll('.carousel[data-carousel="single-items"] [data-video] video'),
        }

        if(this.carousel.hasVideo){ 
            this.hero.section.classList.add('has--video')

            each(this.carousel.videos, (video) => {
                video.onloadeddata = (event) => { // On Video Loaded
                    gsap.to(event.target.parentNode.querySelector('img[data-subject]'), {
                        autoAlpha: 0,
                        overwrite: 'auto'
                    })

                    gsap.to(event.target, { 
                        delay: 1,
                        autoAlpha: 1,
                        overwrite: 'auto'
                    })
                }
            })
        }

        this.preloader = new imagesLoaded(this.carousel.images);

        this.preloader.on( 'done', ( instance ) => {
            each(instance.images, (image) => {
                var status = image.isLoaded ? 202 : 404;
    
                if(status === 404){ 
                    console.log(image.img.src, status)
                }
            })

            this.createCarousel(this.carousel.element); // Init Carousel
        })
    }

    createCarousel(target) {
        let carousel = new Swiper(target, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: "fade",
            autoplay: false,
            speed: 1200,
            loop: false,
            rewind: true,
            navigation: {
                nextEl: this.carousel.next,
                prevEl: this.carousel.prev,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        })

        // Only if has a video Inside
        if(this.carousel.hasVideo){
            this.videoBehaviour(carousel)
        } else {
            carousel.on('slideNextTransitionStart slidePrevTransitionStart', () => {
                this.carousel.prev.style.pointerEvents = 'none'
                this.carousel.next.style.pointerEvents = 'none'
    
                let currentSlide = carousel.slides[carousel.activeIndex]
            })
    
            carousel.on('slideNextTransitionEnd slidePrevTransitionEnd', () => {
                this.carousel.prev.style.pointerEvents = 'auto'
                this.carousel.next.style.pointerEvents = 'auto'
            })
        }
    }

    videoBehaviour = (carousel) => {
        each(this.carousel.videos, (video) => {
            video.onloadeddata = (event) => { // On Video Loaded
                gsap.to(event.target.parentNode.querySelector('img[data-subject]'), {
                    autoAlpha: 0,
                    overwrite: true
                })

                gsap.to(event.target, { 
                    delay: 1,
                    autoAlpha: 1,
                    overwrite: true
                })
            }

            video.onended = (event) => { // On video end go to next slide
                carousel.slideNext()
                event.target.currentTime = 0
            }
        })

        if (carousel.slides[carousel.activeIndex].hasAttribute('data-video')) {
            var currentVideo = this.carousel.videos[carousel.realIndex]

            currentVideo.play() // Play the video to load the meta
        }

        carousel.on('slideNextTransitionStart slidePrevTransitionStart', () => {
            this.carousel.prev.style.pointerEvents = 'none'
            this.carousel.next.style.pointerEvents = 'none'

            let currentSlide = carousel.slides[carousel.activeIndex]
            let currentVideo = currentSlide.querySelector('video')

            each(this.carousel.videos, (video)=> {
                gsap.to(video, {
                    duration: carousel.originalParams.speed / 1000,
                    autoAlpha: 0,
                    onComplete: () => {
                        video.pause()
                        video.currentTime = 0.1
                    }
                })
            })

            each(this.carousel.images, (image) => {
                gsap.to(image, {
                    autoAlpha: 0,
                })
            })

            gsap.to(currentSlide.querySelector('img[data-subject]'), {
                autoAlpha: 1,
            })

            currentVideo.currentTime = 0.1
        })

        carousel.on('slideNextTransitionEnd slidePrevTransitionEnd', () => {
            this.carousel.prev.style.pointerEvents = 'auto'
            this.carousel.next.style.pointerEvents = 'auto'

            let currentSlide = carousel.slides[carousel.activeIndex]
            let currentVideo = currentSlide.querySelector('video')

            currentVideo.play()
            
            gsap.to(currentSlide.querySelector('img[data-subject]'), {
                delay: .5,
                autoAlpha: 0,
            })

            if(currentVideo.readyState >= 2){

                gsap.to(currentVideo, {
                    delay: 1,
                    autoAlpha: 1, 
                    overwrite: true,
                    onStart: () => {
                        currentVideo.currentTime = 0.1
                        currentVideo.play()
                    } 
                })
            }
        })
    }
}